exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".agents-scroll{height:170px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./directives/freeforms/agents/agents.css
// module id = 374
// module chunks = 0